import React from 'react';
import { useEffect, useRef } from 'react'

import "./scrolltext.css"

export const ScrollTextPrompt = ({placeholdertext, text, disabled, rows}) => {


  const textAreaRef = useRef(null);

  
  useEffect(() => {
    
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto';
      //textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
      //Get the lesser of scrollHeight or 300
      const newHeight = Math.min(textAreaRef.current.scrollHeight, 300); // Get the lesser of scrollHeight or 300
      textAreaRef.current.style.height = `${newHeight}px`; // Set the height

      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`; // Set the height to scrollHeight
      textAreaRef.current.style.maxHeight = '300px'; // Set the maximum height
      textAreaRef.current.style.overflowY = 'auto'; // Enable vertical scrollbar if content exceeds max height
    }
    

  }, []);

  
  return (
    <textarea className="scrollTextPrompt"
               id = 'myTextarea'
               ref = {textAreaRef} 
               
                placeholder={placeholdertext}
                value={text}
                disabled={disabled}

                rows={rows}
                wrap="soft"
              />
  );

};

ScrollTextPrompt.defaultProps = {
  disabled: true,
  placeholdertext: '',
  rows: 1,
}
